import { useState, useEffect } from 'react'
import * as styles from './styles'

import usePersistedState from 'src/hooks/usePersistedState'

import {
  CLOSED_STATUS,
  PUBLISHED_STATUS,
  PUBLISHED_SCREEN,
  PENDING_PUBLISHED_SCREEN,
  PENDING_PUBLISHED_STATUS,
  PENDING_APPROVAL_STATUS,
  PENDING_APPROVAL_SCREEN,
  DRAFT_STATUS,
  RECUSED_STATUS
} from 'src/components/NewsModule/constants'
import Spinner from 'src/components/Spinner'
import { checkCan } from 'src/utils/Permissions/permissions'
import CareerListItem from './CareerListItem'
import { getCareers } from 'src/services/api/WebApi/NewsModule/newsModule'
import { useQuery } from 'react-query'
import { IGetCareers } from 'src/services/api/WebApi/NewsModule/interfaces'

const JobNotFound = ({ type }: { type?: 'empty' | 'error' | 'search' }) => (
  <styles.JobNotFoundContainer>
    <styles.JobNotFoundText>
      <styles.JobNotFoundP1>Nenhuma Vaga Encontrada!</styles.JobNotFoundP1>
      <styles.JobNotFoundP2>
        {type === 'search'
          ? 'Não encontramos a vaga que você está procurando.'
          : type === 'empty'
          ? 'Não há vagas disponíveis no momento.'
          : 'Houve um erro ao buscar as vagas.'}
      </styles.JobNotFoundP2>
    </styles.JobNotFoundText>
  </styles.JobNotFoundContainer>
)

const ListCareers = () => {
  const [user] = usePersistedState('auth-token', '')
  const [careerList, setCareerList] = useState<IGetCareers[] | null>(null)
  const [filter, setFilter] = useState('')

  const {
    isLoading,
    isError,
    data: careerData,
    error
  } = useQuery<IGetCareers[], Error>(['getCareers'], () => getCareers())

  const handleChange = (value: any) => {
    setFilter(value)
  }

  useEffect(() => {
    if (!careerData || !careerData.length) {
      return
    }

    const filterBy = (
      postStatus: string,
      status: string,
      hasPermission: boolean
    ) => {
      if (postStatus === status) {
        return hasPermission
      }
      return false
    }
    const filterPublicCareers = (post: any) => {
      return post.status === PUBLISHED_STATUS
    }

    const canApprove = checkCan(user, PENDING_APPROVAL_SCREEN, 'Edit')
    const canPublish = checkCan(user, PENDING_PUBLISHED_SCREEN, 'Edit')
    const canEditPublished = checkCan(user, PUBLISHED_SCREEN, 'Edit')

    let careers = careerData?.filter(
      (post: any) =>
        filterBy(post.status, PENDING_APPROVAL_STATUS, canApprove) ||
        filterBy(post.status, PENDING_PUBLISHED_STATUS, canPublish) ||
        filterBy(post.status, PUBLISHED_STATUS, canEditPublished) ||
        filterBy(post.status, DRAFT_STATUS, canEditPublished) ||
        filterBy(post.status, RECUSED_STATUS, canEditPublished) ||
        filterBy(post.status, CLOSED_STATUS, canEditPublished) ||
        filterPublicCareers(post)
    )

    if (filter.length > 0) {
      careers = careers.filter((post: any) =>
        post.title.toLowerCase().includes(filter.toLowerCase())
      )
    }

    setCareerList(careers)
  }, [careerData, filter])

  if (isLoading) {
    return (
      <styles.ResponsiveContainer>
        <Spinner heightContainer="100vh" size={'60px'} />
      </styles.ResponsiveContainer>
    )
  }

  return (
    <styles.ResponsiveContainer>
      <styles.Container>
        <styles.TitleWrapper>
          <styles.Title>VAGAS</styles.Title>
          <styles.InputWrapper>
            <styles.SearchIcon size={40} />
            <styles.Input
              value={filter}
              onChange={(ev) => {
                handleChange(ev.target.value)
              }}
              placeholder="Procurar por título da vaga"
              type="text"
            />
          </styles.InputWrapper>
        </styles.TitleWrapper>
        {isError ? (
          <JobNotFound type="error" />
        ) : careerList && careerList.length === 0 ? (
          <JobNotFound type="empty" />
        ) : filter && careerList && careerList.length === 0 ? (
          <JobNotFound type="search" />
        ) : (
          <styles.CareersWrapper>
            {careerList &&
              careerList.map((data) => {
                const canEdit = checkCan(user, PUBLISHED_SCREEN, 'Edit')
                const canDelete = checkCan(user, PUBLISHED_SCREEN, 'Delete')
                return (
                  <styles.CareersWrapperItem key={data.id}>
                    <CareerListItem
                      id={data.id}
                      title={data.title}
                      regime={data.alt}
                      status={data.status}
                      post={data}
                      canEdit={canEdit}
                      canDelete={canDelete}
                    />
                  </styles.CareersWrapperItem>
                )
              })}
          </styles.CareersWrapper>
        )}
      </styles.Container>
    </styles.ResponsiveContainer>
  )
}

export default ListCareers
